"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimarySnackbar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _core = require("./core");

var _propTypes = require("prop-types");

var _SvgBtClose = require("../svg/icons/SvgBtClose");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["classes"];
(0, _loadStyles.default)(".caec503f6{bottom:1.5rem;box-sizing:border-box;left:50%;right:auto;-webkit-transform:translate(-50%,calc(100% + 1.125rem + 1.5rem));transform:translate(-50%,calc(100% + 1.125rem + 1.5rem));transition:-webkit-transform 225ms cubic-bezier(0,0,.2,1) 0s;transition:transform 225ms cubic-bezier(0,0,.2,1) 0s;transition:transform 225ms cubic-bezier(0,0,.2,1) 0s,-webkit-transform 225ms cubic-bezier(0,0,.2,1) 0s;display:flex;z-index:999;position:fixed;align-items:center;justify-content:center}.cc3a22388{max-width:24rem;box-sizing:content-box;display:grid;grid-template-columns:1fr fit-content(100%);grid-gap:.3125rem;line-height:1.125rem;padding:1rem 1.5rem;align-items:center;border-radius:.25rem;box-shadow:0 .1875rem .3125rem -.0625rem rgba(0,0,0,.2),0 .375rem .625rem 0 rgba(0,0,0,.14),0 .0625rem 1.125rem 0 rgba(0,0,0,.12)}.cb88fe0a7{display:none}.cda593b08{visibility:visible}.cea559b3d{display:none}.caad84def{cursor:pointer;height:1.75rem}.c57fffd16{-webkit-transform:translateX(-50%);transform:translateX(-50%)}.c00820329 .cc3a22388{background-color:var(--color-flomni-blue-70);color:var(--color-flomni-blue-10)}.c5d24f053 .cc3a22388{background-color:var(--color-flomni-green-70);color:var(--color-flomni-bg-3)}.c77604f34 .cc3a22388{background-color:var(--color-flomni-rose-70);color:var(--color-flomni-rose-10)}");
var styles = {
  root: 'caec503f6',
  content: 'cc3a22388',
  icon: 'cb88fe0a7',
  message: 'cda593b08',
  buttons: 'cea559b3d',
  close: 'caad84def',
  '--open': 'c57fffd16',
  '--view-usual': 'c00820329',
  '--view-success': 'c5d24f053',
  '--view-warning': 'c77604f34'
};

var PrimarySnackbar = function PrimarySnackbar(props) {
  var classes = props.classes,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(_core.CoreSnackbar, (0, _extends2.default)({}, rest, {
    cn: cn,
    nodeClose: /*#__PURE__*/_react.default.createElement(_SvgBtClose.SvgBtClose, null),
    buttons: null
  }));
};

exports.PrimarySnackbar = PrimarySnackbar;
var view = ['usual', 'success', 'warning'];
PrimarySnackbar.modes = {
  view: view
};
PrimarySnackbar.propTypes = {
  /* component logic props */
  messages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    message: _propTypes.node.isRequired,
    view: (0, _propTypes.oneOf)(view)
  })).isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimarySnackbar.defaultProps = {
  classes: {}
};